<template>
    <div class="searchSettingBox">
        <el-collapse v-model="activeNames">
            <el-collapse-item title="内容" name="1">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <span>搜索提示</span>
                    <el-input style="width: 250px;" v-model="data.text" maxlength="10" show-word-limit></el-input>
                </div>
            </el-collapse-item>
            <el-collapse-item title="内容样式" name="2">
                <ul class="settingUl">
                    <li>
                        <span>样式</span>
                        <el-radio-group v-model="data.styleValue" size="mini">
                            <el-radio-button label="描边"></el-radio-button>
                            <el-radio-button label="填充"></el-radio-button>
                        </el-radio-group>
                    </li>
                    <li v-if="data.styleValue === '描边'">
                        <span>描边颜色</span>
                        <el-color-picker v-model="data.miaoColor"></el-color-picker>
                    </li>
                    <li v-else>
                        <span>填充颜色</span>
                        <el-color-picker v-model="data.tianColor"></el-color-picker>
                    </li>
                    <li>
                        <span>边角</span>
                        <el-radio-group v-model="data.jiaoValue" size="mini">
                            <el-radio-button label="直角"></el-radio-button>
                            <el-radio-button label="圆角"></el-radio-button>
                        </el-radio-group>
                    </li>
                    <li>
                        <span>文本位置</span>
                        <el-radio-group v-model="data.alignValue" size="mini">
                            <el-radio-button label="居左"></el-radio-button>
                            <el-radio-button label="居中"></el-radio-button>
                        </el-radio-group>
                    </li>
                </ul>
            </el-collapse-item>
            <el-collapse-item title="组件样式" name="3">
                <comSetting :infoItme="data.infoItme"/>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
<script>

import comSetting from '../comSetting'

export default {
  name: 'seachSetting',
  components: { comSetting },
  props: {
    data: Object
  },
  data () {
    return {
      input: '',
      activeNames: ['1'],
      styleRadio: '描边',
      color2: '',
      color3: '',
      biaoRadio: '直角',
      textRadio: '居左'
    }
  },
  methods: {
  },
  mounted () {
    console.log(this.data)
  }
}
</script>

<style scoped>
.searchSettingBox {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/seach/seachSetting.vue